// this file is generated from the root of the admin repo
// see https://github.com/tocktix/admin/wiki/Svg-Icons-Components in order to add a new file;
import * as React from "react";
import SvgIcon, { SvgIconProps } from "@material-ui/core/SvgIcon";

export const SvgIconRotateClockwise = (props: SvgIconProps) =>
  React.createElement(
    SvgIcon,
    { width: "1em", height: "1em", viewBox: "0 0 24 24", ...props },
    <path d="M17.614 10C16.747 7.77 14.521 6 12 6c-3.232 0-6 2.741-6 6 0 3.262 2.759 6 6 6a6.05 6.05 0 004.243-1.757l1.414 1.414A8.05 8.05 0 0112 20c-4.34 0-8-3.629-8-8 0-4.37 3.67-8 8-8 2.995 0 5.628 1.802 6.999 4.26V4L21 6v6.001L14.999 12l-2-2z" />
  );
export default SvgIconRotateClockwise;
